var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyCrown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "u1F451",
    clipPath: "url(#clip0_283_1117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.41 18.4602L21.0924 9.42662C21.1668 9.02702 20.7414 8.72102 20.3862 8.91962L17.3886 10.5954C16.5516 11.0634 15.495 10.7928 14.9856 9.98042L12.4068 5.86862C12.2184 5.56862 11.7816 5.56862 11.5938 5.86862L9.01502 9.98042C8.50562 10.7928 7.44902 11.0628 6.61202 10.5954L3.61442 8.91962C3.25922 8.72102 2.83382 9.02642 2.90822 9.42662L4.59062 18.4602",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.4602 21.3102H5.5398C4.9698 21.3102 4.59 20.9304 4.59 20.3604V18.4602H19.41V20.3604C19.41 20.8356 19.0302 21.3102 18.4602 21.3102Z",
    fill: "#FFAD00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 5.64299C12.8394 5.64299 13.5198 4.96256 13.5198 4.12319C13.5198 3.28383 12.8394 2.60339 12 2.60339C11.1606 2.60339 10.4802 3.28383 10.4802 4.12319C10.4802 4.96256 11.1606 5.64299 12 5.64299Z",
    fill: "#FFAD00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.8802 9.33959C22.7196 9.33959 23.4 8.65915 23.4 7.81979C23.4 6.98043 22.7196 6.29999 21.8802 6.29999C21.0409 6.29999 20.3604 6.98043 20.3604 7.81979C20.3604 8.65915 21.0409 9.33959 21.8802 9.33959Z",
    fill: "#FFAD00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.11981 9.33959C2.95917 9.33959 3.63961 8.65915 3.63961 7.81979C3.63961 6.98043 2.95917 6.29999 2.11981 6.29999C1.28044 6.29999 0.600006 6.98043 0.600006 7.81979C0.600006 8.65915 1.28044 9.33959 2.11981 9.33959Z",
    fill: "#FFAD00"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_283_1117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyCrown);
export default __webpack_public_path__ + "static/media/daily_crown.11fed3ba8b09ff52c04387f08e414d3b.svg";
export { ForwardRef as ReactComponent };